module.exports = __webpack_public_path__ + "static/media/404.950fa15f.gif";